module.exports = __webpack_public_path__ + "static/media/divideSFX.fb561eb8.mp3";